export const TABS = [
  { to: '/', label: 'Home', chromeLabel: 'Home', end: true },
  { to: '/places', label: 'Places', chromeLabel: 'Places', end: false },
  { to: '/favorites', label: 'Favorites', chromeLabel: 'Favorites', end: false },
  { to: '/resort', label: 'Rocha Brava', chromeLabel: 'Rocha Brava', end: false },
  { to: '/map', label: 'Map', chromeLabel: 'Map', end: false },
  { to: '/flights', label: 'Flights', chromeLabel: 'Flights', end: false },
  { to: '/more', label: 'More', chromeLabel: 'More', end: false },
] as const;

export type TabTo = (typeof TABS)[number]['to'];
